<template>
  <section>
    <div class="notFoundCnt" v-on:click="sectionClicked">
      <Header ref="header"/>
      <div class="notFound">
        <img src="../assets/not-found.png">
        <h4>404</h4>
        <h2 v-if="lang === 'id'">Halaman tidak ditemukan</h2>
        <h2 v-else>Page Not Found</h2>
        <p v-if="lang === 'en'">We can't find the page you looking for</p>
        <p v-else>Kami tidak dapat menemukan halaman yang kamu cari</p>
        <a :href="`/${langCode}`" class="btn secondary">
          <span v-if="lang === 'id'">Ke Halaman Utama</span>
          <span v-else>Back To Home</span>
        </a>
      </div>
    </div>
    <Footer/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'notFound',
  components: { Header, Footer },
  data() {
    return {
      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
  },
  mounted() {
    const pathArr = this.$route.path.split('/');
    if (pathArr.length >= 2 && ['id-id', 'en-us'].includes(pathArr[1])) {
      [this.langCode] = pathArr;
      this.lang = this.langCode === 'id-id' ? 'id' : 'en';
    }
  },
};
</script>

<style scoped lang="scss"></style>
